require('ta-semantic-ui/semantic/dist/components/icon.css');
require('ta-semantic-ui/semantic/dist/components/button.css');
require('ta-semantic-ui/semantic/dist/components/dimmer.css');
require('./section5.styl');

import React from 'react';

const dataSource = require('json!../main/data/daten_alltext.json');

class Section5 extends React.Component {

    constructor(props) {

      super(props);

      this.state = ({
        mietPreis: 0,
        steuerEinkommen: 0,
        steuernMarriedP75: 0,
        steuernUnmarriedP75: 0,
        steuernMarriedP25: 0,
        steuernUnmarriedP25: 0
      })

    }

  niceComma(value) {
    let str = value.toString();
    let newValue = str.replace(".",",");
    return newValue;
  }

  niceNumber(value, sep) {
    if (sep == null) {
      sep = '\'';
    }

    value = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, sep);

    return value;
  };

  componentWillReceiveProps(props) {
    if(this.props.quarter != '') {

      // Calculate data when new props arrive

      for(let i=0; i<dataSource.length; i++) {



        if(dataSource[i].QuarSort == props.quarter && dataSource[i].SteuerJahr == 2014 && dataSource[i].SteuerTariflang == 'Verheiratet') {
          // console.log(dataSource[i])
          this.setState({
            einkArmSumMarried: dataSource[i].eink_arm_Sum,
            antArmSumMarried: dataSource[i].ant_eink_arm
          })
        }

        if(dataSource[i].QuarSort == props.quarter && dataSource[i].SteuerJahr == 2014 && dataSource[i].SteuerTariflang == 'Grundtarif') {
          this.setState({
            einkArmSumUnmarried: dataSource[i].eink_arm_Sum,
            antArmSumUnmarried: dataSource[i].ant_eink_arm
          })
        }

      }

    }
  }


  render() {

        return (

            <div className='section four wrapper'>

                <div className={`ui  dimmable ${this.props.readerMadeHisChoice ? '' : 'dimmed'} segment padded`}>
                    <div className='ui inverted simple dimmer'></div>
                        {/*<h3>Neun Operationen, neun Vollnarkosen</h3>*/}
                            <p className='section-text'>
                              Zirka <a href='http://www.lokalinfo.ch/news/?tx_ttnews%5Btt_news%5D=9540&cHash=1ad71582a19244b6ff08eb1335cb39cb' target='_blank'>400 Menschen haben im vergangenen Winter</a> im Pfuusbus von Pfarrer Sieber in der Stadt Zürich geschlafen – im ganzen Kanton schätzt man die Zahl der Obdachlosen auf <a href='http://www.woerter-blog.ch/wp-content/uploads/2016/11/ta_20161116_0_0_19.pdf' target='_blank'>rund 600</a>. Sie entsprechen dem Armutsklischee, aber Tausende von Armut Betroffene, so wie Oliver, tun dies nicht. <strong>Was also heisst eigentlich «arm sein»?</strong>                            </p>

                  <p className='section-text'>
                              Die Frage zu beantworten, ist schwierig. Es gibt verschiedene Ansätze.
                    <strong>&nbsp;Die absolute Definition:</strong> Die Armutsgrenze entspricht dem sozialen Existenzminimum gemäss <a href='http://skos.ch/uploads/media/2016_SKOS-Richtlinien-komplett-d.pdf' target='_blank'>Richtlinien der Skos</a>, Schweizerische Konferenz für Sozialhilfe. Für eine Einzelperson wie Oliver heisst das: monatlich 986 Franken für den Grundbedarf, plus Miete, plus Krankenkasse. Für eine Familie mit zwei Kindern beträgt der Grundbedarf 2110 Franken.
                            </p>
                  <p className='section-text'>
                    <strong>Die relative Definition:</strong> Laut dem <a href='https://www.stadt-zuerich.ch/content/dam/stzh/portal/Deutsch/Stadtrat%20&%20Stadtpraesident/Publikationen%20und%20Broschueren/Stadtratsbeschluesse/2013/Okt/StZH_StRB_2013_0917.pdf' target='_blank'>Zürcher Stadtrat</a> gilt als armutsgefährdet, wer weniger als 60 Prozent des mittleren Einkommens verdient. Die Armutsgrenze liegt bei der Hälfte des verfügbaren mittleren Einkommens. In der Stadt Zürich waren das 2014 gemäss Steuerdaten 43'332 Ledige (27,2 Prozent) und 9536 Ehepaare (19,9 Prozent).

                              { this.props.quarter != undefined && this.props.readerIsCityCitizen == true &&
                              <span
          className={`personalised text`}>In dem Quartier, in dem Sie wohnen, waren es {this.state.einkArmSumUnmarried} Unverheiratete ({this.niceComma(this.state.antArmSumUnmarried)} Prozent) und {this.state.einkArmSumMarried} Ehepaare ({this.niceComma(this.state.antArmSumMarried)} Prozent).</span>
        }
                    &nbsp;Insgesamt hat der Anteil seit 1999 um einige Prozentpunkte zugenommen – um 2,6 bei den Ledigen und 4,1 bei den Verheirateten. Am stärksten ist die relative Armut im Stadtkreis 12 angestiegen.
                  </p>

                </div>

            </div>
        );
    }
}

Section5.defaultProps = {};

Section5.propTypes = {
    readerIsCityCitizen: React.PropTypes.bool,
    readerMadeHisChoice: React.PropTypes.bool,
    quarter: React.PropTypes.string,
    circle: React.PropTypes.string
};

export default Section5;



// WEBPACK FOOTER //
// ./src/components/section5/section5.js